import React from "react";

function None401({history}) {

  // const goBack = () => {
  //   history.goBack();
  // };

  return (
    <section className="none404">
      <div className="alertWrap">
        <h2>PLM2.0<br/>시스템 접근 권한이 없습니다</h2>
        <p>통합권한을 통해 권한신청 후, 접속 부탁드립니다.</p>

        {/*<button className="btnSec mgr-8" onClick={goBack}>이전 페이지로 돌아가기</button>*/}
        {/*<button className="btnPrm">홈 바로가기</button>*/}
      </div>
    </section>
  );
}

export default None401;
